import { useEffect } from "react";
import { STREAM_STATUS } from "../../../../utility/LiveStreamSocket/LiveStreamConfig";

interface UseStreamModalsParams {
  organizerData: any;
  userData: any;
  updateModalState: (key: string, value: boolean) => void;
}

export function useStreamModals({ organizerData, userData, updateModalState }: UseStreamModalsParams) {
  // Winner / Great Effort / Event Completed
  useEffect(() => {
    if (!organizerData?.eventDetails || !userData) return;
    const { publicVotingEnabled, resultStatus, streamStatus, disputeEndTime } =
      organizerData.eventDetails;
    if (!resultStatus) return;

    const { dispute, resultSubmitted, winner } = resultStatus;

    if (!dispute && resultSubmitted) {
      if (winner === userData?.username) {
        updateModalState("showWinnerModal", true);
      } else if (winner && winner !== userData?.username) {
        updateModalState("greatEffortPopup", true);
      }
    }

    if (
      !publicVotingEnabled &&
      streamStatus?.organiser === STREAM_STATUS.COMPLETED &&
      winner === null &&
      !disputeEndTime &&
      resultSubmitted === false &&
      resultStatus.status &&
      resultStatus.status[userData?.username] === STREAM_STATUS.PENDING
    ) {
      updateModalState("isEventCompletedModalVisible", true);
    }
  }, [
    organizerData?.eventDetails?.resultStatus?.winner,
    organizerData?.eventDetails?.resultStatus?.dispute,
    organizerData?.eventDetails?.resultStatus?.resultSubmitted,
    organizerData?.eventDetails?.streamStatus?.organiser,
    organizerData?.eventDetails?.publicVotingEnabled,
    userData?.username,
    updateModalState
  ]);

  // Dispute windows
  useEffect(() => {
    if (!organizerData?.eventDetails || !userData) return;
    const { resultStatus } = organizerData.eventDetails;
    if (!resultStatus) return;
    const { dispute } = resultStatus;
    const { disputeDetails, eventDetails } = organizerData;

    if (!dispute || !disputeDetails || eventDetails.publicVotingEnabled) return;

    const currentUsername = userData.username;
    let currentUserAction: string | null = null;
    if (disputeDetails.organiser?.username === currentUsername) {
      currentUserAction = disputeDetails.organiser?.action;
    } else if (disputeDetails.challenger?.username === currentUsername) {
      currentUserAction = disputeDetails.challenger?.action;
    }

    const disputeTime = new Date(disputeDetails.timestamp).getTime();
    const now = Date.now();
    const diffInMinutes = (now - disputeTime) / (1000 * 60);

    if (currentUserAction === "Pending") {
      if (diffInMinutes < 5) {
        updateModalState("isDisputeModalVisible", true);
      } else {
        updateModalState("isDisputeResultModalVisible", true);
      }
    } else if (currentUserAction === "Submitted") {
      updateModalState("evidencePopup", true);
    }
  }, [
    organizerData?.disputeDetails?.timestamp,
    organizerData?.disputeDetails?.organiser?.action,
    organizerData?.disputeDetails?.challenger?.action,
    organizerData?.eventDetails?.resultStatus?.dispute,
    organizerData?.eventDetails?.publicVotingEnabled,
    userData?.username,
    updateModalState
  ]);

  // Public voting window, winner not declared yet
  useEffect(() => {
    if (!organizerData?.eventDetails || !userData) return;
    const { publicVotingEnabled, resultStatus } = organizerData.eventDetails;
    if (publicVotingEnabled && resultStatus && resultStatus.winner === null) {
      updateModalState("isDisputeResultModalVisible", true);
    }
  }, [
    organizerData?.eventDetails?.publicVotingEnabled,
    organizerData?.eventDetails?.resultStatus?.winner,
    userData,
    updateModalState
  ]);
}

